module.exports = __webpack_public_path__ + "img/arrow_works_left.4f91f6b7.svg";